import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormItemCommonProps, nameWithPrefix } from '.';
import { streetAddressRule } from '../rules';

export const StreetAddressFormItem = ({ keyPrefix, disabled, required }: FormItemCommonProps) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t('Street address')}
      name={nameWithPrefix({ name: 'streetAddress', keyPrefix })}
      rules={[streetAddressRule({ required: Boolean(required) })]}
    >
      <Input disabled={disabled} />
    </Form.Item>
  );
};
